import { sendLeadNote } from "api/Leads";
import { useMutation } from "react-query";
import { toast } from "react-toastify";

export const useLeadNote = () => {
  


  return useMutation(sendLeadNote, {
    onSuccess: () => {

    },
    onError: () => {
      toast.error(`Something went wrong`);
    },
  });
};
